import request from "@/utils/request";

export function fetchList(param) {
  return request({
    url: 'api/console/black/white/get/list',
    method: 'post',
    data: param
  })
}

export function listCreate(param) {
  return request({
    url: 'api/console/black/white/list',
    method: 'post',
    data: param
  })
}

export function listSwitch(param) {
  return request({
    url: 'api/console/black/white/list/apply',
    method: 'post',
    data: param
  })
}

export function listDelete(param) {
  return request({
    url: 'api/console/black/white/list/delete',
    method: 'post',
    data: param
  })
}

